module.exports = __webpack_public_path__ + "img/glide.0d2534eb.svg";